import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStep, PipelineStepConfig} from 'pipelines/PipelineTypes';
import {RenameAndReplaceKey} from 'util/Types';

export type LayoutStep = PipelineStep<PipelineStepType.LAYOUT, 0>;

export type AnalysisDataLayout = RenameAndReplaceKey<
  PipelineStepConfig<PipelineStepType.LAYOUT, 0>,
  'configPath',
  'configPath',
  Array<string | number> // Backend doesn't support defining union[string, number] in the manifest although this is the expected type.
>;

export type AnalysisSection = AnalysisDataLayout['sections'][number];
export type AnalysisGrid = Extract<AnalysisSection, {type: 'GRID'}>;
export type AnalysisConfigForm = Extract<AnalysisGrid['rows'][number][number], {type: 'CONFIG_FORM'}>;
export type AnalysisDataView = Extract<AnalysisGrid['rows'][number][number], {type: 'DATA'}>;
export type AnalysisMarkdown = Extract<AnalysisGrid['rows'][number][number], {type: 'MARKDOWN'}>;
export type AnalysisNestedGrid = Extract<AnalysisGrid['rows'][number][number], {type: 'NESTED_GRID'}>;
export type AnalysisPlaceholderBlock = Extract<AnalysisGrid['rows'][number][number], {type: 'PLACEHOLDER'}>;
export type AnalysisGridBlock =
  | AnalysisConfigForm
  | AnalysisDataView
  | AnalysisMarkdown
  | AnalysisNestedGrid
  | AnalysisPlaceholderBlock;
export type AnalysisConfigFormField = AnalysisConfigForm['configFields'][number];
export type AnalysisConfigSpec = AnalysisConfigFormField['configSpec'];
export type AnalysisConfigReference = AnalysisConfigFormField['configReferences'][number];
export type AnalysisUISchema = AnalysisConfigForm['uiSchema'];
export type AnalysisUISchemaNestedField = Extract<
  AnalysisUISchema['fields'][number]['uiSchema'],
  {type: 'FIELD'}
>;
export type AnalysisUISchemaNestedShape = Extract<
  AnalysisUISchema['fields'][number]['uiSchema'],
  {type: 'SHAPE'}
>;
export type AnalysisUISchemaActionButton = Extract<
  AnalysisUISchemaNestedShape['fields'][number]['uiSchema'],
  {type: 'ACTION_BUTTON'}
>;
export type AnalysisUISchemaMarkdown = Extract<
  AnalysisUISchemaNestedShape['fields'][number]['uiSchema'],
  {type: 'MARKDOWN'}
>;
export type AnalysisStatusReference = NonNullable<
  AnalysisDataLayout['statusDependencies']
>[number]['inputReferences'][number];

export enum AnalysisLayoutStatus {
  RUNNING = 'RUNNING',
  FAILED = 'FAILED',
  READY = 'READY',
}
export type AnalysisLayoutStatusInfo =
  | {status: AnalysisLayoutStatus.READY}
  | {status: AnalysisLayoutStatus.RUNNING; message: string}
  | {status: AnalysisLayoutStatus.FAILED; message: string; reason: string};
